<template>
	<div class="this-page">
		<template>
			<toolBar useSearch @search="searchOrder" @clear="clearSearch"/>
		</template>
		<template>
			<el-table :data="list" stripe style="width: 100%" size="small" :height="tableHeight"  border>
				<el-table-column prop="id" label="编号" width="61" fixed>
				</el-table-column>
				<el-table-column prop="avatar" label="头像" width="61">
					<template slot-scope="scope">
					    <el-avatar shape="square" :size="40" :src="scope.row.avatar"></el-avatar>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="申请团名称" min-width="200">
				</el-table-column>
        <el-table-column prop="avatar" label="团类型" width="61">
          <template slot-scope="scope">
            {{scope.row.billing_plan == 0?'重量':'体积'}}
          </template>
        </el-table-column>
				<el-table-column prop="owner_name" label="申请人昵称" min-width="120">
				</el-table-column>
				<el-table-column prop="owner" label="会员号" min-width="80">
				</el-table-column>
				<el-table-column prop="contact_name" label="联系人" min-width="120">
				</el-table-column>
				<el-table-column prop="contact_mobile" label="联系电话" min-width="120">
				</el-table-column>
				<el-table-column prop="address" label="联系地址" min-width="200">
				</el-table-column>
				<el-table-column prop="max_user" label="人数上限" width="80">
				</el-table-column>
				<el-table-column prop="max_package" label="包裹上限" width="80">
				</el-table-column>
				<el-table-column prop="passcode" label="团口令" width="80">
				</el-table-column>
				<el-table-column prop="note" label="团公告" min-width="180">
				</el-table-column>
				<el-table-column prop="created_at" label="申请时间" width="160">
				</el-table-column>
				<el-table-column prop="created_at" label="操作" width="90" fixed="right">
					<template slot-scope="scope">
					   <el-button type="success" icon="el-icon-check" circle size="mini" @click="adopt(scope.row.id,scope.row.owner)" ></el-button>
					   <el-button type="danger" icon="el-icon-close" circle size="mini" @click="reject(scope.row.id,scope.row.owner)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<template>
				<el-pagination style="margin-top:20px" :current-page="page" background layout="prev, pager, next" :page-count="pageCount"
				 @current-change="pageChange">
				</el-pagination>
			</template>
		</template>

	</div>
</template>
<script>
	import toolBar from '../../components/tool-bar/index.vue'
	export default {
		components:{
			toolBar
		},
		data() {
			return {
				tableHeight: document.documentElement.clientHeight - 165 + 'px',
				load: {
					list: false
				},
				page: 1,
				searchValue:'',
				pageCount: 1,
				list: []
			}
		},
		mounted() {
			var that = this;
			// <!--把window.onresize事件挂在到mounted函数上-->
			window.onresize = () => {
				return (() => {
				  window.fullHeight = document.documentElement.clientHeight;
					
				  that.tableHeight = window.fullHeight - 165 + 'px';  // 高
					
				})()
			  };
			this.getList()
		},
		methods: {
			getList() {
				this.$fetch.post('Group/getGroupList', {
					page: this.page,
					status:0,
					search:this.searchValue
				}, true).then(res => {
					this.load.list = true
					this.list = res.result
					this.pageCount = res.page
				})
			},
			pageChange(e) {
				this.page = e
				this.getList()
			},
			searchOrder(e){
				if(!e){
					this.$message({
						type: 'info',
						message: '当前没有搜索任何信息'
					});  
						return false
				}
				this.searchValue = e
				this.page = 1
				this.getList()

			},
			clearSearch(){
				console.log('清空搜索')
				this.searchValue = ''
				this.page = 1
				this.getList()
			},
			reject(id,owner){
				this.$prompt('请输入拒绝原因', '拒绝申请', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  inputType:'textarea'
				}).then(({ value }) => {
					this.$fetch.post('Group/rejectCreateApply', {
						id: id,
						owner:owner,
						reason:value
					}, true).then(res => {
						this.page = 1
						this.getList()
					})
				}).catch(() => {
				  this.$message({
					type: 'info',
					message: '取消拒绝'
				  });       
				});
			},
			adopt(id,owner){
				this.$fetch.post('Group/adoptCreateApply', {
					id: id,
					owner:owner
				}, true).then(res => {
					this.page = 1
					this.getList()
				})
			}
		}
	}
</script>

<style scoped>
	.this-page {
		padding: 10px;
		background-color: #FFFFFF;
	}
</style>
